import { ListItem } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Colors from '../../../../layout/theme/utils/colors';

const styles = () => ({
  root: {
    backgroundColor: Colors.white,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export const StyledListItem = withStyles(styles)(ListItem);
